<template>
  <Modal v-if="showQRCode" @close="$emit('closeModal')">
    <div class="openQRCode">
      <div class="openQRCode__header">
        <img
          class="openQRCode__header-img"
          src="@/assets/icons/CloseModal.svg"
          alt="Close Modal"
          @click="$emit('closeModal')"
        />
      </div>
      <form>
        <Input
          type="text"
          :value="idActiveDelivery"
          :title="$t('kolliID')"
          disabled
        />
      </form>
      <qrcode-vue :value="idActiveDelivery" :size="300" level="H" />
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import QrcodeVue from 'qrcode.vue';

@Options({
  name: 'OpenQRCode',
  props: ['showQRCode', 'idActiveDelivery'],
  components: {
    QrcodeVue
  }
})
export default class OpenQRCode extends Vue {}
</script>

<style lang="scss" scoped>
.openQRCode {
  max-width: 300px;
  height: 100%;
  padding: 24px;
  .openQRCode__header {
    text-align: right;
    .openQRCode__header-img {
      cursor: pointer;
    }
  }
  form {
    margin: 20px 0;
  }
}
</style>
